import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';

import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

// Api
import secretaria_api from '../../../../api/secretaria_api';

// helpers
import { showMessage } from '../../../../helpers/message';

// componentes
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import CadastroSecretaria from './components/CadastroSecretaria';

//Context
import { useAuth } from "../../../../context/auth"

function Secretaria() {
    const { setLoading } = useAuth()
    //State para secretarias 
    const [listasecretarias, setListaSecretarias] = useState([]);

    //State para visiblidade do modal
    const [isVisibleModal, setIsVisibleModal] = useState(false);

    //State para pegar o id
    const [secretaria_id, setSecretaria_id] = useState(null);

    const loadSecretarias = () => {
        setLoading(true);
        secretaria_api.getList()
            .then(response => setListaSecretarias(response.data))
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    const toggle = () => {
        loadSecretarias();
        setIsVisibleModal(!isVisibleModal)
    };

    useEffect(() => {
        loadSecretarias();
    }, []);

    const editar = (secretariaEditar) => {
        setSecretaria_id(secretariaEditar.id);
        toggle();
    }

    //Variavel que guarda as ações da tabela
    const actions = [actionsTable.editar(editar)];

    //Cabeçalhos da lista de certificados
    const headers = [
        { value: "Identificação", objectValue: "identificacao", align: "left" },
        { value: "Responsavel", objectValue: "responsavel", align: "left" },
        { value: "Status", objectValue: "status", align: "left" }
    ];

    return (
        <>
            {isVisibleModal && <CadastroSecretaria
                isVisibleModal={isVisibleModal}
                toggle={() => {
                    setSecretaria_id(null);
                    toggle();
                }}
                id={secretaria_id}
                setSecretaria_id={setSecretaria_id}
            />}
            <div className="content">
                <div className='d-flex align-items-center justify-content-between mb-4'>
                    <h4 className='text-secondary m-0'>Secretarias</h4>
                    <Button color='success' onClick={() => { toggle() }}>+ Cadastrar</Button>
                </div >
                <TabelaListagem
                    actions={actions}
                    title={"Lista de secretarias"}
                    headers={headers}
                    items={listasecretarias}
                />
            </div>
        </>
    )
}

export default Secretaria;